jQuery(document).ready(function ($) {

  function filterItems(archiveType, filterAttr, itemAttr, showClass, hideClass, showAllClass) {

    let selectedFilters = [];
    let urlParams = new URLSearchParams(window.location.search);
    let selected = urlParams.get('selected');
    if (selected) {
      selectedFilters = selected.split(',');
      // Add active class to the selected filters
      selectedFilters.forEach(filter => {
        $(`body.${archiveType} .case-category-item[data-${filterAttr}="${filter}"]`).addClass('active isLit');
      });
    } else {
      // Show all items by default
      console.log('no selected filters');
      
      // Show all items
      $(`body.${archiveType} .case-grid-item`).removeClass(hideClass).addClass(showClass);
    }
    console.log('selected filters', selectedFilters);
    
    // When clicking a category filter
    $(`body.${archiveType} .case-category-item`).click(function (e) {
      e.preventDefault();
      let filterBy = $(this).data(filterAttr);
      
      if (filterBy === showAllClass && $(this).hasClass('active')) {        
        selectedFilters = selectedFilters.filter(filter => filter !== showAllClass);
        $(this).removeClass('active isLit');
      } else if (filterBy === showAllClass && (!$(this).hasClass('active'))) {
        $(`body.${archiveType} .case-category-item`).not(this).removeClass('active isLit');
        $(this).addClass('active isLit');
        showAll();
        clearUrl();
        return;
      } else if (filterBy !== showAllClass && $(this).hasClass('active')) {
        $(this).removeClass('active isLit');
      } else {
        $(this).addClass('active isLit');
      }

      // Get all selected filters
      selectedFilters = $(`body.${archiveType} .case-category-item.active`).map(function () {
        return $(this).data(filterAttr);
      }).get();

      // Filter items
      $(`body.${archiveType} .case-grid-item`).each(function () {
        let categoriesArr = $(this).data(itemAttr);
        categoriesArr = categoriesArr.replace(/\s/g, '').split(',');
        if (selectedFilters.some(filter => categoriesArr.includes(filter))) {
          $(this).removeClass(hideClass).addClass(showClass);
        } else {
          $(this).removeClass(showClass).addClass(hideClass);
        }
      });

      // Add selected filters csv to url param selected
      updateUrl();

      // fuction for showing all items
      function showAll() {
        $(`body.${archiveType} .case-grid-item`).removeClass(hideClass).addClass(showClass);
        $(`body.${archiveType} .case-category-item`).removeClass('active isLit');
        let currentUrl = window.location.href;
        let newUrl = new URL(currentUrl);
        newUrl.searchParams.delete('selected');
      }

      // funfor updating the URL
      function updateUrl() {
        let selectedFiltersCsv = selectedFilters.join(',');
        let currentUrl = window.location.href;
        let newUrl = new URL(currentUrl);
        newUrl.searchParams.set('selected', selectedFiltersCsv);
        history.pushState({}, '', newUrl.href);
      }

      // function that clears the url param
      function clearUrl() {
        let currentUrl = window.location.href;
        let newUrl = new URL(currentUrl);
        newUrl.searchParams.delete('selected');
        history.pushState({}, '', newUrl.href);
      }

    });
  }

  // Initialize for both types
  filterItems('post-type-archive-native', 'native-filter', 'native-cat', 'show-native', 'hide-native', 'all-native');
  filterItems('post-type-archive-site', 'native-filter', 'native-cat', 'show-native', 'hide-native', 'all-native');

});
